import React, { forwardRef } from 'react';
import { Tile as CarbonTile, TileProps } from '@carbon/react';

export const Tile = forwardRef<HTMLDivElement, TileProps>((props, ref) => (
  <CarbonTile {...props} ref={ref} />
));

Tile.displayName = 'Tile';
